<template>
    <div class="wapper pr" :style="'background-color:'+ (pageData && pageData.theme)">
        <img v-if="showBack" @click="goHome" src="@/assets/image/back.png"  class="back" alt="">
       <router-view></router-view>
       <!-- <div class="tuichu" @click="logout">退出</div> -->
    </div>
</template>

<script>
import Vue from 'vue';
    import { cookie} from '@/assets/js/utils'

// import api from '@/assets/js/api'
// import { cookie } from '@/assets/js/utils'

// api.post('editActRule',{
//     ruleImg: self.ruleImg
// }).then(function (res) {
//     if(res.status==200&&res.data.code==200){
//         self.$message({
//             message: '提交成功',
//             type: 'success'
//         })
//     }else if(res.data.code==199){
//         cookie.set('lg_user','',-1);
//         cookie.set('userName','',-1);
        
//     }
// }).catch(function  (err) {
//     // console.log('ERROR: ',err)
// })
export default {
    data(){
        return {
            showBack: true,
           pageData: {
               theme: '#cd4a3b'
           }
        }
    },
    watch:{
        $route(to,from){
            let t = setTimeout(()=>{
                clearTimeout(t);
                document.documentElement.scrollTop = 0
            },100)
            if(this.$route.path.includes('chou_jiang') && !this.$route.path.includes('chou_jiang_ji_lu')){
                document.getElementsByTagName('html')[0].style.backgroundColor= '#fec49e'

            }else{
                document.getElementsByTagName('html')[0].style.backgroundColor= this.pageData.theme

            }
            if(!(this.$route.path.includes('chou_jiang') || this.$route.path.includes('pai_hang_bang')|| this.$route.path.includes('gui_ze'))){
                this.showBack = false;
            }else{
                this.showBack = true;
            }

            
        }
    },
    // watch:{
    //     $route(to, from){
    //         alert(333)
    //         // 
    //         if(to.name.a.includes('chou_jiang')){
    //             // console.log(to)
    //             this.theme = "red"
    //         }
    //     }
    // },
    mounted() {
        
        // Vue.prototype.pageData = {
        //     theme: '#8f3a2c'
        // }
        let t = setTimeout(()=>{
            clearTimeout(t);
            document.documentElement.scrollTop = 0
        },100)
        if(this.$route.path.includes('chou_jiang') && !this.$route.path.includes('chou_jiang_ji_lu')){
            document.getElementsByTagName('html')[0].style.backgroundColor= '#fec49e'

        }else{
            document.getElementsByTagName('html')[0].style.backgroundColor= this.pageData.theme

        }
        if(!(this.$route.path.includes('chou_jiang') || this.$route.path.includes('pai_hang_bang')|| this.$route.path.includes('da_ti')|| this.$route.path.includes('gui_ze'))){
            this.showBack = false;
        }else{
            this.showBack = true;
        }

    },
    methods: {
        // logout(){
        //     let actid = 1;
        //     cookie.set('token'+actid,'',-1);
        //     cookie.set('shareKey'+actid,'',-1);
        //     cookie.set('query'+actid,'',-1);
        //     cookie.set('fromPlat','',-1);
        //     location.reload()
        // },
        goHome(){
            this.$router.push('/')
        }
    },
}
</script>

<style lang="less">
@import '../assets/css/base.less';
.tuichu {
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    background-color: rgba(0255,255,255,0.6);
    position: fixed;
    right: 0;
    top: 40%;
}

</style>